import type { ChartAccountBalance } from "./types";

export type FlattenedChartRow = {
  node: ChartAccountBalance;
  depth: number;
};

export const flattenChartAccounts = (
  nodes: ChartAccountBalance[],
  depth = 0,
  rows: FlattenedChartRow[] = [],
) => {
  for (const node of nodes) {
    rows.push({ node, depth });
    if (node.children.length) {
      flattenChartAccounts(node.children, depth + 1, rows);
    }
  }
  return rows;
};

export const findChartAccountById = (
  nodes: ChartAccountBalance[],
  accountId: number,
): ChartAccountBalance | null => {
  for (const node of nodes) {
    if (node.id === accountId) {
      return node;
    }
    if (node.children.length) {
      const match = findChartAccountById(node.children, accountId);
      if (match) {
        return match;
      }
    }
  }
  return null;
};
